import './InputText.css'

const InputText = ({handleChange, name, onlyNum=false, value, max, text, placeholder, labelTop = true, isPassword = false}) => {

    const onChange = e => {
        if(onlyNum && isNaN(e.target.value))
            return;

        handleChange(e)
    }

    return (

        <label 
            className={"input-text__wrapper " + (labelTop ? "input-text__label-top" : "input-text__label-left") } 
            htmlFor="login"

        >
            <span className='label '>{text}</span>
            <input
                className="login-form__input input-text "
                type={
                isPassword ? 'password' : 'text'}
                placeholder={placeholder}
                maxLength={max || 10000}
                name={name}
                value={value}
                onChange={onChange}
            />
      </label>
        
    )
}


export default InputText